<template>
  <div class="animated fadeIn">
    <div class="row mb-20">
      <div class="col-6">
        <a @click="openPage('/allForm')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
      </div>
    </div>
    <div class="box">
      <div class="p-20">
        <div class="row mt-10">
          <div class="col-sm-6">
            <b-row>
              <b-col sm="3">
                <label>Type</label>
              </b-col>
              <b-col sm="9">
                <b-form-select @change="changeFormType" name="formType" v-model="formType" :options="options" class="mb-3" />
              </b-col>
            </b-row>
          </div>
          <div class="col-sm-6">
            <b-row>
              <b-col sm="3">
                <label>Branch</label>
              </b-col>
              <b-col sm="9">
                <b-form-select name="branch" v-model="addData.branch_id" @change="changeBranch">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                </b-form-select>
              </b-col>
            </b-row>
          </div>
        </div>
        <template v-if="formType === 'dailyVisit'">
          <form @submit.prevent="validateDailyVisit('dailyVisit')" data-vv-scope="dailyVisit">
            <div class="row justify-content-center mt-30">
              <div class="col-sm-6">
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Name</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom" name="name_visitor" v-model="addData.name" type="text"></b-form-input>
                    <span class="error">{{ errors.first('dailyVisit.name_visitor') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Email</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom" name="email" v-model="addData.email" type="text"></b-form-input>
                    <span class="error">{{ errors.first('dailyVisit.email') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Phone Number</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom" name="phone_number" v-validate="'required|numeric'" v-model="addData.phone_number" type="text"></b-form-input>
                    <span class="error">{{ errors.first('dailyVisit.phone_number') }}</span>
                  </b-col>
                </b-row>
              </div>
              <div class="col-sm-6">
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Amount</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input :value="totalPayment" class="border-bottom" name="amount" v-validate="'required|numeric'" v-model="addData.amount" type="text"></b-form-input>
                    <span class="error">{{ errors.first('dailyVisit.amount') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Created At</label>
                  </b-col>
                  <b-col sm="9">
                    <flat-pickr :config="config" v-model="addData.created_at" name="created_at" class="w-100"></flat-pickr>
                    <span class="error">{{ errors.first('date') }}</span>
                  </b-col>
                </b-row>
              </div>
            </div>
            
            <b-row class="mb-20">
              <b-col sm="2">
                <div class="label-name">Payment 1</div>
              </b-col>
              <b-col sm="5">
                <div class="mb-20">
                  <b-form-select name="paymentType1" @change="changePaymentType1" v-model="addData.payment_type_id_1" class="form-control border-bottom">
                    <option :value="null" selected>Please select</option>
                    <option v-for="item in itemsPaymentType" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                </div>
                <div class="mb-10">
                  <b-form-radio-group class="radio-custom-list" :disabled="[1,6, 9].includes(addData.payment_type_id_1)" name="paymentCard1" v-model="addData.payment_card_id_1">
                    <b-form-radio class="font-13" v-for="item in itemsPaymentCard" :key="item.id" :value="item.id">{{item.name}}</b-form-radio>
                  </b-form-radio-group>
                  <div v-if="![1,9].includes(addData.payment_card_id_1) && addData.payment_card_id_1 != null && addData.payment_card_id_1 == null">
                    <span class="error">The payment_card_id_1 field is required.</span>
                  </div>
                </div>
              </b-col>
              <b-col sm="5">
                <money class="form-control border-bottom custom-currency w-100 bg-transparent" v-model="addData.payment_amount_1" v-bind="money"></money>
              </b-col>
            </b-row>
            <b-row class="mb-20">
              <b-col sm="2">
                <div class="label-name">Payment 2</div>
              </b-col>
              <b-col sm="5">
                <div class="mb-20">
                  <b-form-select name="paymentType2" @change="changePaymentType2" v-model="addData.payment_type_id_2" class="form-control border-bottom">
                    <option :value="null" selected>Please select</option>
                    <option v-for="item in itemsPaymentType" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                </div>
                <div class="mb-10">
                  <b-form-radio-group class="radio-custom-list" :disabled="addData.payment_type_id_2 == 1 || addData.payment_type_id_2 == 6" name="paymentCard2" v-model="addData.payment_card_id_2">
                    <b-form-radio class="font-13" v-for="item in itemsPaymentCard" :key="item.id" :value="item.id">{{item.name}}</b-form-radio>
                  </b-form-radio-group>
                </div>
              </b-col>
              <b-col sm="5">
                <money class="form-control border-bottom custom-currency w-100 bg-transparent" disabled v-model="addData.payment_amount_2" :value="paymentLeft" v-bind="money"></money>
              </b-col>
            </b-row>
            <div class="mb-10">
              <div class="row">
                <b-col sm="2">
                  <div>Notes</div>
                </b-col>
                <b-col sm="10">
                  <textarea class="w-100" rows="5" v-model="addData.notes"></textarea>
                </b-col>
              </div>
            </div>
            <div class="text-right">
              <button :disabled="disableBtnSubmit" type="submit" class="btn-primary">Submit</button>
            </div>
          </form>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'
import { ModelSelect } from 'vue-search-select'

export default {
  name: 'addDailyVisit',
  components: {
    ModelSelect
  },
  data: function () {
    return {
      disableBtnSubmit: false,
      fullNameDetail: '',
      linkDataPrivy: '',
      errorMoney: 'The amount field is required!',
      dataMember: [],
      dataBranch: [],
      dataCS: [],
      config: {
        altInput: true,
        altFormat: 'F j, Y',
        dateFormat: 'Y-m-d'
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'IDR ',
        suffix: '',
        precision: 0,
        masked: false
      },
      money2: {
        decimal: ',',
        thousands: '.',
        prefix: 'IDR ',
        suffix: '',
        precision: 0,
        masked: false
      },
      formType: 'dailyVisit',
      itemsPaymentCard: [],
      itemsPaymentType: [],
      detailMember: {},
      detailCS: {},
      CSName: '',
      modalShow: false,
      linkPrivyId: 'https://sandbox.privy.id/user',
      addData: {
        branch_id: null,
        created_at : '',
        name : '',
        email : '',
        phone_number : '',
        amount: '',
        notes: '',
        payment_type_id_1: '',
        payment_card_id_1: '',
        payment_amount_1: '',
        payment_type_id_2: '',
        payment_card_id_2: '',
        payment_amount_2: '',
        remark: '',
        daily_visit_type: null
      },
      amountPaymentCard1: '',
      amountPaymentCard2: '',
      options: [
        { value: null, text: 'Please select' },
        { value: 'freeze', text: 'Freeze' },
        { value: 'cancel', text: 'Cancel' },
        { value: 'outstanding', text: 'Outstanding' },
        { value: 'wristband', text: 'Wristband' },
        { value: 'lostAndFound', text: 'Lost & Found' },
        { value: 'dailyVisit', text: 'Daily Visit' },
        { value: 'grabAndGo', text: 'Grab & Go' },
        { value: 'grabAndGoGopay', text: 'Grab & Go Gopay' },
        { value: 'corporateOutstanding', text: 'Corporate Invoice Outstanding' }
      ],
      optionsDailyVisitType: [
        { value: null, text: 'Please select' },
        { value: 'Daily Visit', text: 'Daily Visit' },
        { value: 'Package', text: 'Package' },
        { value: 'Event', text: 'Event' },
        { value: 'Others', text: 'Others' },
      ],
      optionsMember: [
        { value: null, text: 'Please select' }
      ]
    }
  },
  methods: {
    changeFormType (event) {
      if (event === 'freeze') {
        this.$router.push('/allForm/addFreeze')
      } else if (event === 'cancel') {
        this.$router.push('/allForm/addCancel')
      } else if (event === 'outstanding') {
        this.$router.push('/allForm/addOutstanding')
      } else if (event === 'wristband') {
        this.$router.push('/allForm/addWristband')
      } else if (event === 'lostAndFound') {
        this.$router.push('/allForm/addLostAndFound')
      } else if (event === 'dailyVisit') {
        this.$router.push('/allForm/addDailyVisit')
      } else if (event === 'grabAndGo') {
        this.$router.push('/allForm/addGrabAndGo')
      } else if (event === 'corporateOutstanding') {
        this.$router.push('/allForm/addCorporateOutstanding')
      } else {
        this.$router.push('/allForm/add')
      }
    },
    formatPrice(value) {
        let val = (value/1).toFixed(0).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    changePaymentType1 (event) {
      if (event === 1) {
        this.addData.payment_card_id_1 = null
      } else if (event === 6) {
        this.addData.payment_card_id_1 = 1
      } else {
        this.addData.payment_card_id_1 = null
      }
    },
    changePaymentType2 (event) {
      if (event === 1) {
        this.addData.payment_card_id_2 = null
      } else if (event === 6) {
        this.addData.payment_card_id_2 = 1
      } else {
        this.addData.payment_card_id_2 = null
      }
    },
    getMemberData (event) {
      axios.get('fitness/v1/member/' + event).then(response => {
        this.detailMember = response.data.data
        this.addDataPrivy.branch_id = response.data.data.branch_id
        this.addDataPrivy.member_id = response.data.data.id
      }).catch(error => {
        console.log('error', error)
      })
    },
    getCSData (event) {
      axios.get('crm/v1/customer_service/' + event).then(response => {
        this.detailCS = response.data.data
        this.CSName = response.data.data.name
        this.addDataPrivy.customer_id = response.data.data.id
      }).catch(error => {
        console.log('error', error)
      })
    },
    formSelect (event) {
      return event
    },
    changeValueMoney (event) {
      if (!(event.key === '')) {
        this.$refs['error-print'].classList.add('hidden')
      } else {
        this.$refs['error-print'].classList.remove('hidden')
      }
    },
    validateDailyVisit (data6) {
      this.$validator.validateAll(data6).then((result) => {
        if(result) {
          axios.put('crm/v1/form_daily_visit/' + this.$route.query.id, this.addData).then(response => {
            this.$router.push('/formReport/dailyVisit')
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            // console.log('error log', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    fetchData() {
      axios.get('crm/v1/form_daily_visit/' + this.$route.query.id).then(response => {
        this.addData.branch_id = response.data.data.branch_id
        this.addData.name = response.data.data.name
        this.addData.email = response.data.data.email
        this.addData.phone_number = response.data.data.phone_number
        this.addData.amount = response.data.data.amount
        this.addData.created_at = response.data.data.created_at
        this.addData.notes = ""
        this.addData.payment_type_id_1 = response.data.data.payment_type_id_1
        this.addData.payment_type_id_2 = response.data.data.payment_type_id_2
        this.addData.payment_card_id_1 = response.data.data.payment_card_id_1
        this.addData.payment_card_id_2 = response.data.data.payment_card_id_2
        this.addData.payment_amount_1 = response.data.data.payment_amount_1
        this.addData.payment_amount_2 = response.data.data.payment_amount_2

        const year = moment(this.addData.created_at).format('YYYY')
        const month = moment(this.addData.created_at).format('M')
        
        axios.get('crm/v1/closing_period/member_pt_session?year='+year+'&bulan='+month).then(response => {
          this.disableBtnSubmit = true
        }).catch(error => {
          console.log('error', error)
        })

      }).catch(error => {
        console.log('error', error)
      })

      axios.get('transaction/v1/payment_type?sorting=id&sorting_type=asc').then(response => {
        this.itemsPaymentType = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('transaction/v1/payment_card?sorting=id&sorting_type=asc&status=active').then(response => {
        this.itemsPaymentCard = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  computed: {
    getMemberId: function() {
      return this.addData.member_id
    },
    totalPayment: function() {
      let calculatedTotal = this.addData.amount
      this.amountPaymentCard1 = this.addData.amount
      return calculatedTotal
    },
    paymentLeft: function() {
      if (String(this.amountPaymentCard1).length > String(this.addData.amount).length) {
        // console.log('test')
        this.amountPaymentCard2 = 0
      } else {
        this.amountPaymentCard2 = this.addData.amount - this.amountPaymentCard1
        this.amountPaymentCard2 = Math.abs(this.amountPaymentCard2)
      }
    }
  },
  watch: {
    getMemberId () {
      axios.get('fitness/v1/member/' + this.addData.member_id).then(response => {
        this.detailMember = response.data.data
        this.fullNameDetail = response.data.data.first_name + ' ' + response.data.data.last_name
        // this.addDataPrivy.branch_id = response.data.data.branch_id
        // this.addDataPrivy.member_id = response.data.data.id
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
